module.exports = __webpack_public_path__ + "img/COK.18f20528.gif";